import { Dispatch, SetStateAction } from "react";
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doFAVORITE_LIST_SET } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_WORKSPACE_FAVORITE_LIST_FETCH = "REQUEST_WORKSPACE_FAVORITE_LIST_FETCH";
export const doREQUEST_WORKSPACE_FAVORITE_LIST_FETCH = createDoRequestAction(
  REQUEST_WORKSPACE_FAVORITE_LIST_FETCH,
);

export const requestWorkspaceFavoriteListFetchActionCreators = {
  doREQUEST_WORKSPACE_FAVORITE_LIST_FETCH,
};

interface Payload {
  type: string;
  payload: {
    requestId: string;
  };
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>;
}

export function* requestWorkspaceFavoriteListFetch({
  payload,
  setRequestResult,
}: Payload): SagaIterator {
  debug("saga*requestWorkspaceFavoriteListFetch");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_FAVORITE_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/workspace-favorite-list-fetch`,
    accessToken,
    data: {},
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_FAVORITE_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/workspace-favorite-list-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doFAVORITE_LIST_SET([...result.payload]));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_WORKSPACE_FAVORITE_LIST_FETCH,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* workspaceFavoriteListFetchSaga() {
  yield takeEvery(REQUEST_WORKSPACE_FAVORITE_LIST_FETCH, requestWorkspaceFavoriteListFetch);
}
